export default (state = {}, action) => {
  switch (action.type) {
    case `UPDATE_ERROR`:
      return action.error;
    case `CLEAR_ERROR`:
      return {};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/error.js